import { Box } from "@mui/material"
import { alpha } from "@mui/material/styles"
import DragHandleIcon from "@mui/icons-material/DragHandle"
import { useLayoutBounds } from "@/features/layout/layoutBounds.jsx"
import { WW_BLUE } from "@/theme/tokens"

// Drag grip on a left panel's right edge (see usePanelWidth). Rendered as a
// sibling of the panel Paper; hidden via display so drag state survives.
export default function PanelResizeHandle({
  visible = true,
  panelWidth,
  panelMaxHeight,
  onMouseDown,
}) {
  const bounds = useLayoutBounds()
  return (
    <Box
      sx={{
        position: "absolute",
        top: bounds.top,
        left: `${bounds.left + panelWidth - 15}px`,
        height: `${panelMaxHeight ?? bounds.panelHeight}px`,
        width: "18px",
        zIndex: 1001,
        display: visible ? "flex" : "none",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      {/* Only the icon is draggable. Rotated so the grip reads as a vertical
          bar for the horizontal drag. */}
      <DragHandleIcon
        onMouseDown={onMouseDown}
        sx={{
          fontSize: 22,
          transform: "rotate(90deg)",
          cursor: "col-resize",
          pointerEvents: "auto",
          color: alpha(WW_BLUE, 0.4),
          "&:hover": { color: WW_BLUE },
        }}
      />
    </Box>
  )
}
